import React, {useCallback} from 'react'
import {connect} from "react-redux";
import {setSQFTActiveButton} from "../../../../actions/sqftMenuFunctions";
import {FormattedMessage, injectIntl} from "react-intl";
import {
  setSqftCroppedSlabImages,
  setActiveStep,
  setActiveSlabUrl, setSlabImageHeight, setSlabImageWidth, addSqftCroppedSlabImage,
} from "../../../../actions/sqftSlabFunctions";
import workspace from "../canvas/core/workspace";
import sqftEventManager from "../canvas/store/sqftEventManager";
import {loaderDisable, loaderEnable} from "../../../ui/loaderView";
import imageCompression from 'browser-image-compression';
import SqftLoadSlabFooterSelectImageTypeButtons from "./SqftLoadSlabFooterSelectImageTypeButtons";
import SlabWorkspace from "../canvas/core/slab/slabWorkspace";
import sqftConfig from "../canvas/store/sqftConfig";

const SqftLoadSlabFooter = (props) => {
  const {activeSlabId, setSQFTActiveButton, setActiveSlabUrl, addSqftCroppedSlabImage, pricePerArea} = props;
  const {slabImageWidth, slabImageHeight} = props;
  const {activeStep, setActiveStep} = props;
  const {cropperRef} = props;

  const prepareImageDraw = useCallback(() => {
    let imageElement,
      imageSource,
      cropper,
      croppedImage;

    imageElement = cropperRef ? cropperRef.current : null;
    cropper = imageElement ? imageElement.cropper : null;

    if (cropper) {
      const croppedCanvas = cropper.getCroppedCanvas();
      if (croppedCanvas) {
        imageSource = croppedCanvas.toDataURL();

        setActiveSlabUrl(imageSource);

        croppedImage = new Image();
        croppedImage.src = imageSource;
        //todo
        let workspaceImage = workspace.addImage(
          croppedImage,
          slabImageWidth / sqftConfig.getMeasureMultiplier(),
          slabImageHeight / sqftConfig.getMeasureMultiplier(),
          null,
          null,
          "slabImage",
          null,
          function () {},
          null,
          null,
          null,
          sqftEventManager.priorities.SLAB_IMAGE,
          activeSlabId
        );
        workspaceImage.setPricePerArea(pricePerArea);

        addSqftCroppedSlabImage(workspaceImage);
      }
      cropper.destroy();
    }

    setTimeout(() => {
      loaderDisable();
    }, 150);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSlabId, addSqftCroppedSlabImage, cropperRef, setActiveSlabUrl, slabImageHeight, slabImageWidth, pricePerArea]);

  const handleCancelClick = () => {
    closePopup();
  };

  const closePopup = () => {
    setSQFTActiveButton("");
  }

  const handleSelectImageClick = () => {
    switch (activeStep) {
      case 1:
        setActiveStep(2);
        break;
      case 2:
        loaderEnable();
        setSQFTActiveButton("");
        SlabWorkspace.init();
        setTimeout(() => {
          prepareImageDraw();
        }, 0);
        break;
    }
  };

  const onImageUploadChange = (event) => {
    let options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    }
    const imageFile = event.target.files[0];
    imageCompression(imageFile, options)
      .then(compressedFile => {
        console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
        console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
        let domString = URL.createObjectURL(compressedFile); // todo we can't save blob, getCroppedCanvas() returns null
        setActiveSlabUrl(domString);
      });

    // FileReader (without image compression) disabled

    // let target = event.target || window.event.srcElement,
    //   files = target.files;
    // if (FileReader && files && files.length) {
    //   let fr = new FileReader();
    //   fr.onload = function (theFile) {
    //     let image = new Image();
    //     image.src = theFile.target ? theFile.target.result : "";
    //     image.onload = function() {
    //       // let roundedWidth = Math.round10(this.width, 1);
    //       // let roundedHeight = Math.round10(this.height, 1);
    //       // let heightGCD = getGCD(roundedHeight, roundedWidth);
    //       // let aspectWidth = roundedWidth / heightGCD;
    //       // let aspectHeight = roundedHeight / heightGCD;
    //       //setSlabImageHeight(DEFAULT_SLAB_IMAGE_PART);
    //       //setSlabImageWidth(DEFAULT_SLAB_IMAGE_PART * aspectWidth / aspectHeight);
    //
    //       // console.log("this.width", this.width);
    //       // console.log("this.height", this.height);
    //       // console.log("heightGCD", heightGCD);
    //       // console.log("aspectWidth", aspectWidth);
    //       // console.log("aspectHeight", aspectHeight);
    //     };
    //
    //     setActiveSlabUrl(fr.result);
    //   };
    //   fr.readAsDataURL(files[0]);
    // }
    // Not supported
    // else {
    //   // fallback -- perhaps submit the input to an iframe and temporarily store
    //   // them on the server until the user's session ends.
    // }
    //target.value = null;

    setActiveStep(2);
  };

  return (
    <div className="message-box-buttons message-box-buttons--modal">
      <div className="message-box-buttons message-box-buttons--modal">
        <button className="ui-button10 ui-button10--blue meta-buttons-confirm-nav--no" onClick={handleCancelClick}>
          <span className="ui-button10-text ui-button10--uppercase">
            <FormattedMessage id={"sqft.popup.buttonCancel"}/>
          </span>
        </button>
        <SqftLoadSlabFooterSelectImageTypeButtons/>
        {/*{*/}
        {/*  activeStep === 0 && slabImageType === SLAB_IMAGE_TYPES.placeholder ?*/}
        {/*    <button className="ui-button10 ui-button10--green meta-buttons-confirm-nav--yes"*/}
        {/*      onClick={() => {handlePlaceholderClick()}}>*/}
        {/*      <span className="ui-button10-text ui-button10--uppercase">*/}
        {/*        <FormattedMessage id={"sqft.popup.slab.next"}/>*/}
        {/*      </span>*/}
        {/*    </button>*/}
        {/*    : null*/}
        {/*}*/}
        {/*{*/}
        {/*  activeStep === 0 && slabImageType === SLAB_IMAGE_TYPES.upload  ?*/}
        {/*    <button className="ui-button10 ui-button10--green meta-buttons-confirm-nav--yes"*/}
        {/*            onClick={() => {setActiveStep(activeStep + 1)}}>*/}
        {/*      <span className="ui-button10-text ui-button10--uppercase">*/}
        {/*        <FormattedMessage id={"sqft.popup.slab.next"}/>*/}
        {/*      </span>*/}
        {/*    </button>*/}
        {/*    : null*/}
        {/*}*/}
        {
          activeStep === 1 && activeSlabId ?
            <button className="ui-button10 ui-button10--green meta-buttons-confirm-nav--yes">
              <label className="slab-header__library-upload">
                <input type="file" onChange={onImageUploadChange} />
                <FormattedMessage id={"sqft.popup.slabmode.upload"}/>
              </label>
            </button>
            : null
        }
        {
          activeStep === 2 ?
            <button className="ui-button10 ui-button10--green meta-buttons-confirm-nav--yes" onClick={handleSelectImageClick}>
              <span className="ui-button10-text ui-button10--uppercase" data-text="sqft.popup.buttonDelete">
                <FormattedMessage id={"sqft.popup.buttonSelectImage"}/>
              </span>
            </button>
            : null
        }
      </div>
    </div>
  )
};

const mapStateToProps = (store) => ({
  activeSlabId: store.sqftSlabState.activeSlabId,
  activeStep: store.sqftSlabState.activeStep,
  slabImageWidth: store.sqftSlabState.slabImageWidth,
  slabImageHeight: store.sqftSlabState.slabImageHeight,
  pricePerArea: store.sqftSlabState.pricePerArea,
  activeButton: store.sqftMenuState.activeButton,
  slabImageType: store.sqftSlabState.slabImageType,
});

const mapDispatchToProps = {
  setSQFTActiveButton,
  setActiveStep,
  setActiveSlabUrl,
  setSqftCroppedSlabImages,
  setSlabImageHeight,
  setSlabImageWidth,
  addSqftCroppedSlabImage,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftLoadSlabFooter)
)

